/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import axios from "../../../api/axiosService";
import FadeInSection from "../../../Components/FadeInSection";
import { sanitize } from "../../../Common/Util";

function About(props) {
  const { t, i18n } = useTranslation();
  const [introduction, setIntroduction] = useState({});

  const getIntroduction = async () => {
    try {
      const response = await axios.get("/api/introduction/info");
      setIntroduction(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getIntroduction();
  }, []);

  return (
    <div className="w-100">
      <div className="global-header-block-1 header">
        <FadeInSection direction="down">
          <div className="about-text normal-text-3">{t("ABOUT_SSL")}</div>
          <h1 className="introduction-title global-title-margin title-1">
            {" "}
            {t("INTRODUCTION")}
          </h1>
        </FadeInSection>
      </div>

      <FadeInSection delay={200}>
        <div className="mb-[50px] md:mb-[150px] w-full flex justify-center">
          <img
            src={introduction.bannerImage}
            alt="SpaceSpeakers Performance"
            className="w-full object-cover"
          />
        </div>
      </FadeInSection>

      <div className="flex justify-center bg-black text-white px-[15px]">
        <div className="w-full max-w-[1200px]">
          <FadeInSection delay={200}>
            <div className="flex flex-col md:flex-row items-center items-center justify-between gap-[50px] md:gap-10 mb-[50px] md:mb-[150px]">
              <div className="text-center md:text-left">
                <h1 className="ssl-title ssl-main-title title-1 mb-[30px]">
                  {introduction.introductionTitle || "WHAT'S SSL ?"}
                </h1>
                <p
                  className="ssl-paragraph normal-text-3 max-w-[700px]"
                  dangerouslySetInnerHTML={sanitize(introduction.description)}
                ></p>
              </div>
              <img
                src="https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/SPACESPEAKERS_Logo-1741878492422.png"
                alt="SS Label Logo"
                className="ssl-logo max-h-[250px] max-w-[204px] object-cover overflow-hidden"
              />
            </div>
          </FadeInSection>

          <FadeInSection delay={200}>
            <div className="flex flex-col md:flex-row justify-between items-stretch gap-[50px] md:gap-[100px] mb-[50px] md:mb-[30px]">
              <div className="intro-first-block flex flex-col text-center md:text-left max-w-[600px]">
                <div className="flex-col">
                  <h1 className="ssl-title title-1 mt-[50px] md:mt-0 mb-[16px]">
                    VISION
                  </h1>
                  <p
                    className="ssl-paragraph normal-text-3"
                    dangerouslySetInnerHTML={sanitize(introduction.vision)}
                  />
                </div>
                <div className="flex-col">
                  <h1 className="ssl-title title-1 mt-[50px] md:mt-0 mb-[16px]">
                    MISSION
                  </h1>
                  <p
                    className="ssl-paragraph normal-text-3"
                    dangerouslySetInnerHTML={sanitize(introduction.mission)}
                  />
                </div>
                <div className="flex-col">
                  <h1 className="ssl-title title-1 mt-[50px] md:mt-0 mb-[16px]">
                    VALUE
                  </h1>
                  <p
                    className="ssl-paragraph normal-text-3"
                    dangerouslySetInnerHTML={sanitize(
                      introduction?.value ?? "VALUE",
                    )}
                  />
                </div>
                <div className="flex-col">
                  <h1
                    className="block md:hidden intro-nevasleep mt-[50px] text-center"
                    dangerouslySetInnerHTML={sanitize(introduction.slogan)}
                  />
                </div>
              </div>
              <div className="w-full h-[300px] md:w-[500px] md:min-w-[500px] md:h-auto self-stretch">
                <img
                  src={introduction.visionImage}
                  alt="Vision"
                  className="w-full h-full object-cover rounded-none md:rounded"
                />
              </div>
            </div>
          </FadeInSection>
          <FadeInSection delay={200}>
            <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-[50px] md:gap-10 md:mb-[16px]">
              <div className="text-center md:text-left">
                <h1 className="ssl-title title-1 mb-0 md:mb-[20px]">SLOGAN</h1>
              </div>
              <div className="text-center md:text-left mb-[50px] md:mb-[40px] md:mb-[0px]">
                {/* <p
                  className="ssl-paragraph normal-text-3 max-w-[630px]"
                  dangerouslySetInnerHTML={sanitize(
                    introduction.sloganDescription ||
                      " Âm nhạc của chúng tôi ko bao giờ ngủ",
                  )}
                /> */}
              </div>
            </div>
          </FadeInSection>

          <FadeInSection delay={200}>
            <h1 className="hidden md:block intro-nevasleep pb-[50px] md:pb-[100px] text-center">
              {introduction.slogan}
            </h1>
          </FadeInSection>

          <FadeInSection delay={200}>
            <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-[50px] md:gap-10 md:mb-[16px]">
              <div className="text-center md:text-left">
                <h1 className="ssl-title title-1 mb-0 md:mb-[20px]">
                  OUR SERVICE
                </h1>
              </div>
              <div className="text-center md:text-left mb-[50px] md:mb-[40px] md:mb-[0px]">
                <p
                  className="ssl-paragraph normal-text-3 max-w-[630px]"
                  dangerouslySetInnerHTML={sanitize(introduction.service)}
                />
              </div>
            </div>
          </FadeInSection>

          <FadeInSection delay={200}>
            <div className="mb-[50px] md:mb-[60px] md:mb-[150px] flex flex-col md:flex-row items-center justify-between gap-10">
              <img
                src={introduction.serviceImage}
                alt="Service"
                className="w-100 max-w-[100vw] object-cover intro-post-img"
              />
            </div>
          </FadeInSection>
        </div>
      </div>
    </div>
  );
}

export default About;
